import Cookies from 'js-cookie';

import {
	COOKIE_KEY_PREFERRED_PROMO_SOURCE,
	COOKIE_KEY_PROMO_SOURCE,
	QUERY_PARAM_PROMO_SOURCE,
} from 'constants/queryAndStorageKeys';

/**
 * @return {string | undefined}
 */
export const promoSourceFromCookie = () => Cookies.get(COOKIE_KEY_PROMO_SOURCE);
export const preferredPromoSourceFromCookie = () => Cookies.get(COOKIE_KEY_PREFERRED_PROMO_SOURCE);

const setCookieIfNotExists = (key, value, options) => {
	if (!Cookies.get(key)) {
		Cookies.set(key, value, options);
	}
};

export const storePromoSourceToCookie = (promoSource) =>
	setCookieIfNotExists(COOKIE_KEY_PROMO_SOURCE, promoSource, { expires: 30 });

export const storePreferredPromoSourceToCookie = (promoSource) =>
	Cookies.set(COOKIE_KEY_PREFERRED_PROMO_SOURCE, promoSource, { expires: 30 });

export const promoSourceFromQuery = (queryParams) => queryParams[QUERY_PARAM_PROMO_SOURCE];

export const promoSourceFromCookieOrQuery = (queryParams) => {
	const promoFromCookie = promoSourceFromCookie();
	const preferredPromoFromCookie = preferredPromoSourceFromCookie();

	if (queryParams && promoSourceFromQuery(queryParams)) {
		return promoSourceFromQuery(queryParams);
	}

	if (preferredPromoFromCookie) {
		return preferredPromoFromCookie;
	}

	return promoFromCookie;
};
